
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqehd8sdqUqkdgORcQHZVlrAiL6K26RUF8dxNHkvORMfkMeta } from "/codebuild/output/src1105942046/src/src/pages/faq.vue?macro=true";
import { default as menuSg9_OhZgEt3DJcwbrygWoRXv9umqtfZhQsCRJ82SW_450Meta } from "/codebuild/output/src1105942046/src/src/pages/menu.vue?macro=true";
import { default as indexxpI_xMzDkcUkowkUw7TdqZBnRzq4sVBFP3mg_qMe_ksMeta } from "/codebuild/output/src1105942046/src/src/pages/index.vue?macro=true";
import { default as contactq5ihkJaIGS8VQdB1lAwfTwNOYw2jnCxrTw80u_45_pQp8Meta } from "/codebuild/output/src1105942046/src/src/pages/contact.vue?macro=true";
import { default as tutorialf1PV_ZiaIhcOMfnsguGG4PQzmr8Khpp6_yC432lhMXwMeta } from "/codebuild/output/src1105942046/src/src/pages/tutorial.vue?macro=true";
import { default as agreementu6QUl88blAHtonVXRtzQoJO2zqNaqIEhrGtuszayGakMeta } from "/codebuild/output/src1105942046/src/src/pages/agreement.vue?macro=true";
import { default as about_45passHpSeMjOWGKtvQYxhLYfKuMjYoMZdwC7FZup2bZl3tcAMeta } from "/codebuild/output/src1105942046/src/src/pages/about-pass.vue?macro=true";
import { default as indexy_NZMqEos7RUuUB3dWqyvVvslSguCCO7Aq1aVbzFIa4Meta } from "/codebuild/output/src1105942046/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93HPJanC9DNwOpiXb4yNY6EJmKjkntRH8TspjAf7zM1bcMeta } from "/codebuild/output/src1105942046/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceOq2t330ZwgPh0Pt2FIvyrzGFt668JuDSXGv_4570X8PTIMeta } from "/codebuild/output/src1105942046/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93WdKW2U3zHlhgb6oFW7ybBTak84c5X8CoIrqQpr2NiUMMeta } from "/codebuild/output/src1105942046/src/src/pages/notice/[id].vue?macro=true";
import { default as indexnyuHQzzHz_wkP8oMVSXtUN26YJDCPJQMLZA66GI9_45uUMeta } from "/codebuild/output/src1105942046/src/src/pages/coupon/index.vue?macro=true";
import { default as indexYPtEeJBUMbu_45IFe_45dwC5fJ7_459wgIDogMg8LR0ldBXUcMeta } from "/codebuild/output/src1105942046/src/src/pages/mypage/index.vue?macro=true";
import { default as indexE98K21KgB3RbqpNHbzxrwjdmODSLwECUCL_45xCSPl7MQMeta } from "/codebuild/output/src1105942046/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93oXUDPAr_45FKNwKj5GOnoRU_45nuQouE_AlQk0_S35N4hpUMeta } from "/codebuild/output/src1105942046/src/src/pages/parking/[id].vue?macro=true";
import { default as indexlex6_45Hzw3hs8_45oJrRn3VAxfT1TlZBQe62bIJRJ6u9OcMeta } from "/codebuild/output/src1105942046/src/src/pages/history/index.vue?macro=true";
import { default as index6VQQgOcTiTNYwe40nlnjCgLPXIBEDVAbIDOv1E9FdSgMeta } from "/codebuild/output/src1105942046/src/src/pages/monthly/index.vue?macro=true";
import { default as indexdmQrHLXikXE_45vJDjXIUPkRpKWBhruoKrnffxh459awQMeta } from "/codebuild/output/src1105942046/src/src/pages/sign-in/index.vue?macro=true";
import { default as index4jqJsMxGfy35wJtWLNY_BmHsXxraDZIYux1fUaSy__8Meta } from "/codebuild/output/src1105942046/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviwseocEubbSUOJsFlAbTmPaADQ_nrLvpW_45eh701cQNe4Meta } from "/codebuild/output/src1105942046/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editj_451z9WbC27KmQdh_459WHpkM8yB5rQ7HSNRKOngm4KekgMeta } from "/codebuild/output/src1105942046/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementa_45hcon2sxdnkM5XsvqMQNk_bfdWnr8hdxdu8WXjYOY0Meta } from "/codebuild/output/src1105942046/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexItWwQYd91dHh_45rpZvqVJEmwHegsKAa7VXq_hV_LBe1MMeta } from "/codebuild/output/src1105942046/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453d3CwzOIuo1KT34qo6_tIptiLNARe_cZ2winNN4P3pF2sMeta } from "/codebuild/output/src1105942046/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmXuyEJFhF3SY5apP0QJbXfTOpvNnDhQW7DylqdKZ6KGgMeta } from "/codebuild/output/src1105942046/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexaj10twibOOuRp0EfsZLQXomzCTNRFBr_45Da9WF9HS52cMeta } from "/codebuild/output/src1105942046/src/src/pages/card/create/index.vue?macro=true";
import { default as indexdiBhk0MbsQqct6yyVvvvbTXfc702NBG5nmzCcPnegyQMeta } from "/codebuild/output/src1105942046/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirm5adPJ1dZIGqmfBsm07qRxjroA_45mgOC6arArf3P0hYmYMeta } from "/codebuild/output/src1105942046/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmDGHCLjWEn1VSGn_45_45FK7B_45GpjHLu7FS5zP5vscqgm3h8Meta } from "/codebuild/output/src1105942046/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeo0NvtoCwqSvYD1jP_45f3W4UksTeOmgV0Sjx_1UIibuIoMeta } from "/codebuild/output/src1105942046/src/src/pages/membership/complete.vue?macro=true";
import { default as registerOwpLglcaI2kkwekSEgYHi7BiDDO3Z9HwTJv8kcBovQoMeta } from "/codebuild/output/src1105942046/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93zeVhhNBFEd5SXg2Kncm7PDxcBSHl2FLU55ZoyNTL0gwMeta } from "/codebuild/output/src1105942046/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmHW563ZNfPl_45uV5sa_0pZrBgeQWg_45zpfnfbO7wF6FkMwMeta } from "/codebuild/output/src1105942046/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_936IA4IAjPOD458QECUqMqIBwaXpG0EwClrAmseOkvyGUMeta } from "/codebuild/output/src1105942046/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as index9KAsJlQjtiQ7y3Op00YzGGqUmery_Mczlqc38DUbpdsMeta } from "/codebuild/output/src1105942046/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeAQRrBGFBO_45tsINUTSKUDM8zNf0WYQiuoEi9hIlcPAV8Meta } from "/codebuild/output/src1105942046/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codevd732fhDASHXiiENiuypsCQkXzof1kbQdO9g2_45OXXr4Meta } from "/codebuild/output/src1105942046/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completegIxX9IOuCuHwtkfoRjkMvgpHQWZs_bijHffGVbyeiu8Meta } from "/codebuild/output/src1105942046/src/src/pages/contact-form/complete.vue?macro=true";
import { default as register5lLyVF4PpM2eT0ryoNQ0G0v4zUlcOxCJuh7sAoyAEn0Meta } from "/codebuild/output/src1105942046/src/src/pages/contact-form/register.vue?macro=true";
import { default as complete8_giQZW6pJXxM80fjd4Yi_7Bf9oC8cxaZmTaQwwir7kMeta } from "/codebuild/output/src1105942046/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexQ8SA4OndBeBIxWtmjrKIZxsRNOdknFh4LF9gLBjh87MMeta } from "/codebuild/output/src1105942046/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmEdT1vMeC3xulr1TuQ3XXRh6dd1fkdAbDbqSzZHmKwb8Meta } from "/codebuild/output/src1105942046/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeMjh7c5lFJGFlFSeQ7856vqVZdU0x1WbtvSA6D372LTYMeta } from "/codebuild/output/src1105942046/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexC2mOm_keIkBa7ubhYrVxJIoxw5feNWJ9gTiAb2MpZlcMeta } from "/codebuild/output/src1105942046/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93R0vnR6PW_HCyVhjgmtDwE7vcUia_45QPyW7Yvw7m4tZ6QMeta } from "/codebuild/output/src1105942046/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeDp2etVAe93ShEVB3CReObYmMwgsAEZW16H708CV4N8EMeta } from "/codebuild/output/src1105942046/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasbgyaneDN3OufL8ba1IMjFLNGeqCDhZYcjWipjNKDYBAMeta } from "/codebuild/output/src1105942046/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleQ0ATd5pjeUkPp2vsC1ZMVjd5LQpLyJgMOSRo02NUhW4Meta } from "/codebuild/output/src1105942046/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailcESOTtZjJp_Ga9HWWMHthuqoLxa_dbxknB_NWs6jARQMeta } from "/codebuild/output/src1105942046/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmr2GvxD_kJM0DsSzZIXsgor2avwGsUdxzAEdoA4drOm4Meta } from "/codebuild/output/src1105942046/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentA96nwyXFnAJNm_wVyyZQ3fj7t6tIAwTNgWtnxa6I4NUMeta } from "/codebuild/output/src1105942046/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmsNg8pADRne3sW4pzvhnnJhY38_HwWuWVqpvIPGpXhXYMeta } from "/codebuild/output/src1105942046/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedategGDEELQTvqVohc61RkAQ5_spdKBMxcNBd6_45KFT5Si70Meta } from "/codebuild/output/src1105942046/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeUDiH0O4HEI8yDhqYQ2FyRdWNDMDeSNFLNkD2dU94S7AMeta } from "/codebuild/output/src1105942046/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45coderArAd2Iyg9f4quRSMpQt3KIjfPf2j1vFSVBtrFNAftAMeta } from "/codebuild/output/src1105942046/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordEQvljXXEilLAhThyOshZgYcMz7pGYGjzsSi6f9V97o8Meta } from "/codebuild/output/src1105942046/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliascjD_jeUshwDNOCmHmNfpLdzwdyqZdDixNGuC7NfqossMeta } from "/codebuild/output/src1105942046/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerit3PzFWSxKci54B4EQk5Ya4lONQta3J498RJ_9JbtxQMeta } from "/codebuild/output/src1105942046/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeuJlxG9nmNAwZqmFSE9GQZwvxWoTag7CAupl_45isS6bvMMeta } from "/codebuild/output/src1105942046/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexhSHGcEVy9JfEorh7u6ujH3Fuqw65nyGGO_457Mg8l2PWEMeta } from "/codebuild/output/src1105942046/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indext3mnVmArfo13n4ZukrvBjhkXXEYGb6Y22T4MHanEjXEMeta } from "/codebuild/output/src1105942046/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexIu_457FHQCkxVmh8BUl3qwm2KQmJJb0WDIuXvV2zO1xS4Meta } from "/codebuild/output/src1105942046/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexSKQUQYOxA5hjH9wf0YgQFuYCEyFSh1fs6HXz_45F8VYVwMeta } from "/codebuild/output/src1105942046/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatei2ZdA59T7Jn_dbdABMwXCjSc1Nhsgs4zaH1BxiP_45x8YMeta } from "/codebuild/output/src1105942046/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as complete913u2YTzdirarR_rM3KWfyk_Iup6A6_t7GBIdqK6bbEMeta } from "/codebuild/output/src1105942046/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmMG58zYN_45qDuGPz0Au93715Gei3hnmDnhQHfZgwdmegkMeta } from "/codebuild/output/src1105942046/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexmZzOdZ0G4UdFPu3579bBGHcDsnKLy1y0rGyNzchcUYwMeta } from "/codebuild/output/src1105942046/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeVA6dStO2YLReDgq9XERehEGKhOGtK9LI47ZYZPp_7e8Meta } from "/codebuild/output/src1105942046/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateZtyiLjh9xRdIkmBu7Si4x2I5dlHy0i6sponLueWUWh8Meta } from "/codebuild/output/src1105942046/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexQ_45SFmFL5x4a4x2xjtbuHjDdCtU3QLkkCsySkQBwoNuwMeta } from "/codebuild/output/src1105942046/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexlw6_VIzmxsJzc1A0dj45gbPcfOZ69DUUAov_bFCwn2MMeta } from "/codebuild/output/src1105942046/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as complete7D_EU2nSrrRqBSOtffAWh7VDwD6ZiIdr5ZiAsdJeRo8Meta } from "/codebuild/output/src1105942046/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as index_45LMtqAo5_r7JLUy0A1KMh1Z2ndhx6HWxSpFrewO_2KUMeta } from "/codebuild/output/src1105942046/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codepCPkhFHDn_ACGWmG_k_Blei_45vxFJzKg_45OZyBkAAmI7oMeta } from "/codebuild/output/src1105942046/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexj_45_MAsFZwpLc3VAo6irH10Svm5k99YD_zUX3ULzaM2QMeta } from "/codebuild/output/src1105942046/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as index_jjLe_45SeNAw5iCSvXQck7TEVhsw5DPemKbrrBXBs6gwMeta } from "/codebuild/output/src1105942046/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexWSz0SOSqEASAYTN0zXp_Ielcp6sdhXASVErlUYJc6nQMeta } from "/codebuild/output/src1105942046/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as update6mN_0UztqxaHQ0t9Jej8Of7CAVmqa0UPn4GLGxB0R1oMeta } from "/codebuild/output/src1105942046/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirm1Yn8foNzXQlcs0E3XRYRsJ4Q7U3bqIFPV2BI3wQtyHYMeta } from "/codebuild/output/src1105942046/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuSg9_OhZgEt3DJcwbrygWoRXv9umqtfZhQsCRJ82SW_450Meta || {},
    component: () => import("/codebuild/output/src1105942046/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexxpI_xMzDkcUkowkUw7TdqZBnRzq4sVBFP3mg_qMe_ksMeta || {},
    component: () => import("/codebuild/output/src1105942046/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexnyuHQzzHz_wkP8oMVSXtUN26YJDCPJQMLZA66GI9_45uUMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src1105942046/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src1105942046/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src1105942046/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src1105942046/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexlex6_45Hzw3hs8_45oJrRn3VAxfT1TlZBQe62bIJRJ6u9OcMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src1105942046/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexdmQrHLXikXE_45vJDjXIUPkRpKWBhruoKrnffxh459awQMeta || {},
    component: () => import("/codebuild/output/src1105942046/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: index4jqJsMxGfy35wJtWLNY_BmHsXxraDZIYux1fUaSy__8Meta || {},
    component: () => import("/codebuild/output/src1105942046/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1105942046/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1105942046/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexaj10twibOOuRp0EfsZLQXomzCTNRFBr_45Da9WF9HS52cMeta || {},
    component: () => import("/codebuild/output/src1105942046/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src1105942046/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirm5adPJ1dZIGqmfBsm07qRxjroA_45mgOC6arArf3P0hYmYMeta || {},
    component: () => import("/codebuild/output/src1105942046/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmDGHCLjWEn1VSGn_45_45FK7B_45GpjHLu7FS5zP5vscqgm3h8Meta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src1105942046/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeo0NvtoCwqSvYD1jP_45f3W4UksTeOmgV0Sjx_1UIibuIoMeta || {},
    component: () => import("/codebuild/output/src1105942046/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerOwpLglcaI2kkwekSEgYHi7BiDDO3Z9HwTJv8kcBovQoMeta || {},
    component: () => import("/codebuild/output/src1105942046/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmHW563ZNfPl_45uV5sa_0pZrBgeQWg_45zpfnfbO7wF6FkMwMeta || {},
    component: () => import("/codebuild/output/src1105942046/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeAQRrBGFBO_45tsINUTSKUDM8zNf0WYQiuoEi9hIlcPAV8Meta || {},
    component: () => import("/codebuild/output/src1105942046/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codevd732fhDASHXiiENiuypsCQkXzof1kbQdO9g2_45OXXr4Meta || {},
    component: () => import("/codebuild/output/src1105942046/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completegIxX9IOuCuHwtkfoRjkMvgpHQWZs_bijHffGVbyeiu8Meta || {},
    component: () => import("/codebuild/output/src1105942046/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: register5lLyVF4PpM2eT0ryoNQ0G0v4zUlcOxCJuh7sAoyAEn0Meta || {},
    component: () => import("/codebuild/output/src1105942046/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmEdT1vMeC3xulr1TuQ3XXRh6dd1fkdAbDbqSzZHmKwb8Meta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src1105942046/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeMjh7c5lFJGFlFSeQ7856vqVZdU0x1WbtvSA6D372LTYMeta || {},
    component: () => import("/codebuild/output/src1105942046/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexC2mOm_keIkBa7ubhYrVxJIoxw5feNWJ9gTiAb2MpZlcMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1105942046/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeDp2etVAe93ShEVB3CReObYmMwgsAEZW16H708CV4N8EMeta || {},
    component: () => import("/codebuild/output/src1105942046/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1105942046/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleQ0ATd5pjeUkPp2vsC1ZMVjd5LQpLyJgMOSRo02NUhW4Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1105942046/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailcESOTtZjJp_Ga9HWWMHthuqoLxa_dbxknB_NWs6jARQMeta || {},
    component: () => import("/codebuild/output/src1105942046/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmr2GvxD_kJM0DsSzZIXsgor2avwGsUdxzAEdoA4drOm4Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1105942046/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentA96nwyXFnAJNm_wVyyZQ3fj7t6tIAwTNgWtnxa6I4NUMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1105942046/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmsNg8pADRne3sW4pzvhnnJhY38_HwWuWVqpvIPGpXhXYMeta || {},
    component: () => import("/codebuild/output/src1105942046/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeUDiH0O4HEI8yDhqYQ2FyRdWNDMDeSNFLNkD2dU94S7AMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1105942046/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45coderArAd2Iyg9f4quRSMpQt3KIjfPf2j1vFSVBtrFNAftAMeta || {},
    component: () => import("/codebuild/output/src1105942046/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordEQvljXXEilLAhThyOshZgYcMz7pGYGjzsSi6f9V97o8Meta || {},
    component: () => import("/codebuild/output/src1105942046/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1105942046/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerit3PzFWSxKci54B4EQk5Ya4lONQta3J498RJ_9JbtxQMeta || {},
    component: () => import("/codebuild/output/src1105942046/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeuJlxG9nmNAwZqmFSE9GQZwvxWoTag7CAupl_45isS6bvMMeta || {},
    component: () => import("/codebuild/output/src1105942046/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src1105942046/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]